import { render, staticRenderFns } from "./team-inbox-maintenance.vue?vue&type=template&id=5c6ee5f9&scoped=true"
import script from "./team-inbox-maintenance.vue?vue&type=script&lang=js"
export * from "./team-inbox-maintenance.vue?vue&type=script&lang=js"
import style0 from "./team-inbox-maintenance.vue?vue&type=style&index=0&id=5c6ee5f9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c6ee5f9",
  null
  
)

export default component.exports